export default __webpack_public_path__ + "static/media/icon-trust.086682a8.svg";